import { createApp } from 'vue'
import App from './App.vue'
import './assets/css/tailwind.css'

const containerId = 'bike-registration'
const rootElement = document.getElementById(containerId)
const rootElementData = rootElement ? rootElement.dataset : []

createApp(App, {
  params: {
    containerId,
    ...rootElementData,
  },
}).mount(`#${containerId}`)
